import { useMemo } from 'react'

import { Layout } from '@loadsmart/miranda-react'

import { isEmpty } from '../../utils/array'
import { type Commodity as CommodityType } from '../domain/Commodity'
import { type ShippingItemsMeasures, type ShippingItem } from '../domain/ShippingItem'
import { getTotalHandlingUnitCount } from '../domain/ShippingItem'
import {
  formatShippingItemToHandlingUnit,
  createCommodityFromHandlingUnit,
} from '../presenters/HandlingUnitPresenter'
import Commodity from './Commodity'
import { HandlingUnit } from './HandlingUnit'
import { ShippingItemsSummary } from './ShippingItemsSummary'

export function ShippingItems({
  measures = {},
  shippingItems,
}: {
  measures?: ShippingItemsMeasures
  shippingItems: ShippingItem[]
}) {
  const normalizedShippingItems: ShippingItem[] = useMemo(
    () =>
      shippingItems.map(handlingUnit => {
        if (!handlingUnit.commodities || handlingUnit.commodities.length === 0) {
          return {
            ...handlingUnit,
            commodities: [createCommodityFromHandlingUnit(handlingUnit)],
          }
        }

        return handlingUnit
      }),
    [shippingItems]
  )

  return (
    <Layout.Box backgroundColor="color-background-primary" padding="none">
      <ShippingItemsSummary
        measures={measures}
        count={getTotalHandlingUnitCount(shippingItems)}
        showContent={measures && !isEmpty(shippingItems)}
      />
      {normalizedShippingItems.map((handlingUnit, index) => (
        <HandlingUnit index={index} handlingUnit={formatShippingItemToHandlingUnit(handlingUnit)}>
          {handlingUnit.commodities?.map((commodity: CommodityType) => (
            <Commodity commodity={commodity} />
          ))}
        </HandlingUnit>
      ))}
    </Layout.Box>
  )
}
